// Aviso de ficha alterada (pedido da Aline em 23/10/2026: a baixa feita na Baixa de Pagamento não aparecia na ficha já
// aberta). A tela que grava algo numa ficha fora da própria ficha chama avisarFichaAlterada(); as fichas abertas, nesta aba
// do navegador (outras abas do sistema) ou em outra aba do navegador (BroadcastChannel), conferem na hora se mudaram
// (BaseDeDadosCreateEdit, GET /devedor/versao/{id}). Mudança feita por outro usuário a ficha pega pela conferência a cada 30 s.
const EVENTO = "fichaAlterada";
const CANAL = "ral-ficha-alterada";
// Identifica esta aba: o BroadcastChannel também entrega aos outros canais da mesma aba, que já receberam o evento
const ESTA_ABA = `${Date.now()}-${Math.random()}`;

const novoCanal = () => {
    try {
        return typeof BroadcastChannel !== "undefined" ? new BroadcastChannel(CANAL) : null;
    } catch (e) {
        return null;
    }
};

let canalDeEnvio = null;

export const avisarFichaAlterada = () => {
    window.dispatchEvent(new Event(EVENTO));
    try {
        if (!canalDeEnvio) canalDeEnvio = novoCanal();
        if (canalDeEnvio) canalDeEnvio.postMessage({ aba: ESTA_ABA });
    } catch (e) {
        // Sem o canal, as outras abas do navegador pegam a mudança pela conferência periódica
    }
};

/** Chama {@code callback} quando alguma tela avisa que mexeu numa ficha; devolve a função que para de ouvir. */
export const aoAlterarFicha = (callback) => {
    window.addEventListener(EVENTO, callback);
    const canal = novoCanal();
    if (canal) {
        canal.onmessage = (e) => {
            if (e?.data?.aba !== ESTA_ABA) callback();
        };
    }
    return () => {
        window.removeEventListener(EVENTO, callback);
        if (canal) canal.close();
    };
};
